import { render, staticRenderFns } from "./CollegeItem.vue?vue&type=template&id=098affe6&scoped=true"
import script from "./CollegeItem.vue?vue&type=script&lang=ts"
export * from "./CollegeItem.vue?vue&type=script&lang=ts"
import style0 from "./CollegeItem.vue?vue&type=style&index=0&id=098affe6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098affe6",
  null
  
)

export default component.exports